export const HERO_FRAME_WIDTH = 64;

export const HER0_FRAME_HEIGHT = 64;

export const HERO_COLUMN_LENGTH = 13;
